import { get } from "../GenericServices";

const ExportSF = {
  exportSF: (filters = {}) => {
    return get(`export-sf`, filters, "blob");
  },
};

export default ExportSF;
